module.exports = __webpack_public_path__ + "static/header-376d1bd9b53996a75a14646ae06e3707.svg";